import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  row: {
    background: '#fff',
  },
}));
